import React from 'react';

const EmptyState = ({
  icon = '🔍',
  title = 'No results',
  description = 'Try adjusting your filters or search query.',
  style = {},
  children,
}) => {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        textAlign: 'center',
        padding: 40,
        color: 'rgba(255, 255, 255, 0.7)',
        background: 'rgba(10,10,15,0.35)',
        border: '1px solid rgba(102,126,234,0.15)',
        borderRadius: 16,
        ...style,
      }}
    >
      <div style={{ fontSize: '2.4rem', marginBottom: 12 }}>{icon}</div>
      <div style={{ fontWeight: 600, marginBottom: 6 }}>{title}</div>
      <div style={{ opacity: 0.8, marginBottom: 12 }}>{description}</div>
      {children}
    </div>
  );
};

export default EmptyState;

